export default __webpack_public_path__ + "static/media/partner2.0848138e.svg";